export default __webpack_public_path__ + "f8e3d2566112bb74b19286045e111570.png";